module.exports = __webpack_public_path__ + "img/pin-protection.daf10878.jpg";